module.exports = __webpack_public_path__ + "img/facebookicon.46afebfd.svg";